<template>
  <van-tabbar fixed padding=".34rem" active-color="#09366b" fontsize="28px" class="footer-bar" v-model="active">
    <van-tabbar-item v-for="(item, index) in tabbarData" @click="linkTo(item)" :key="index">
      {{item.title}}
      <span class="iconfont" slot="icon" slot-scope="props" :class="props.active ? item.icon.active : item.icon.normal"></span>
    </van-tabbar-item>
    <!--<div class="scan">-->
      <!--<div>-->
        <!--<span class="iconfont iconsaoma"></span>-->
      <!--</div>-->
    <!--</div>-->
  </van-tabbar>
</template>

<script>
export default {
  name: 'tabbar',
  data () {
    return {
      active: 0,
      tabbarData: [
        {
          title: '首 页',
          icon: {
            active: 'iconshouyefill',
            normal: 'iconshouye'
          },
          path: '/home',
          index: 0
        },
        // {
        //   title: '扫 码',
        //   path: '',
        //   icon: {
        //     active: 'iconsaoma',
        //     normal: 'iconsaoma'
        //   },
        //   index: 2
        // },
        {
          title: '我 的',
          icon: {
            active: 'iconwodefill',
            normal: 'iconwode'
          },
          path: '/user',
          index: 1
        }
      ]
    }
  },
  computed:{},
  methods: {
    linkTo(item) {
      this.$router.replace({path: item.path})
    },
    routerPath(to, from) {
      // if (from === '/user') {
      //   this.active = 0
      // }else {
      //   this.active = 1
      // }
      this.tabbarData.forEach( res => {
        if(to.path === res.path) {
          this.active = res.index
        }
      })
    },
  },
  watch:{
    '$route.path': 'routerPath'
  },
  mounted () {
    this.routerPath(this.$route)
  },
  created () {},
  components: {}
}
</script>

<style lang='less'>
  .footer-bar{
    .van-tabbar-item__text{
      font-size: 10px;
    }
    .iconfont{
      font-size: 20px;
    }
    .van-tabbar-item--active{
      color: #00d8a0 !important;
    }
    .scan{
      position: absolute;
      bottom: 1.6vh;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: #fff;
      left: 50%;
      margin-left: -28px;
      z-index: 2;
      box-shadow: 0px 5px 7px rgba(0, 216, 160, .3);
      display: flex;
      justify-content: center;
      align-items: center;
      div{
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        width: 48px;
        height: 48px;
        background: #00d8a0;
        border-radius: 50%;
        text-align: center;
        span{
          font-size: 28px;
          line-height: 56px;
          color: #ffffff;
        }
      }
    }
  }
</style>
